import { render, staticRenderFns } from "./mesajComponent.vue?vue&type=template&id=e85e45a2&"
import script from "./mesajComponent.vue?vue&type=script&lang=js&"
export * from "./mesajComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports